(() => {
  const popup = document.querySelector('[data-macht-welcome]');
  if (!popup || popup.dataset.initialised === 'true') return;
  popup.dataset.initialised = 'true';

  const dialog = popup.querySelector('.macht-welcome__dialog');
  const closeButtons = [...popup.querySelectorAll('[data-welcome-close]')];
  const copyButton = popup.querySelector('[data-welcome-copy]');
  const success = popup.dataset.success === 'true';
  const delay = Math.max(0, Number(popup.dataset.delay || 7000));
  const dismissDays = Math.max(1, Number(popup.dataset.dismissDays || 7));
  const dismissedKey = 'machtWelcomeDismissedAt';
  const subscribedKey = 'machtWelcomeSubscribed';
  let lastFocused = null;

  const storageGet = (key) => {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  };
  const storageSet = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  };

  const recentlyDismissed = () => {
    const dismissedAt = Number(storageGet(dismissedKey) || 0);
    return dismissedAt && (Date.now() - dismissedAt) < dismissDays * 86400000;
  };

  const focusable = () => [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')]
    .filter((el) => el.offsetParent !== null);

  const open = () => {
    if (popup.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('macht-welcome-lock');
    window.setTimeout(() => {
      const email = popup.querySelector('input[type="email"]');
      (email || dialog)?.focus({ preventScroll: true });
    }, 180);
  };

  const close = (remember = true) => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('macht-welcome-lock');
    if (remember) storageSet(dismissedKey, String(Date.now()));
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
  };

  closeButtons.forEach((button) => button.addEventListener('click', () => close(true)));

  document.addEventListener('keydown', (event) => {
    if (!popup.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
      return;
    }
    if (event.key !== 'Tab') return;
    const nodes = focusable();
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });

  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const code = copyButton.dataset.code || '';
      const label = copyButton.querySelector('[data-copy-label]');
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        if (label) label.textContent = 'COPIED';
      } catch (e) {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try { document.execCommand('copy'); if (label) label.textContent = 'COPIED'; } catch (err) {}
        textarea.remove();
      }
      window.setTimeout(() => { if (label) label.textContent = 'COPY'; }, 1800);
    });
  }

  if (success) {
    storageSet(subscribedKey, 'true');
    try { window.localStorage.removeItem(dismissedKey); } catch (e) {}
    open();
    return;
  }

  if (storageGet(subscribedKey) === 'true' || recentlyDismissed()) return;
  window.setTimeout(open, delay);
})();
